var path = 'ng-table/filters/text.html';
var html = "<input type=text name={{name}} ng-disabled=$filterRow.disabled ng-model=params.filter()[name] class=\"input-filter form-control\" placeholder=\"{{getFilterPlaceholderValue(filter, name)}}\"/> ";
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/browser/filters/text.html
// module id = 39
// module chunks = 0